<script setup lang="ts">
import { inject } from "vue";
import { EDITOR_TYPE_KEY } from "../keys";
import PopupLeftChrome from "./PopupLeftChrome.vue";
import SidebarEmailRail from "./SidebarEmailRail.vue";

const editorType = inject(EDITOR_TYPE_KEY, "email");
</script>

<template>
  <PopupLeftChrome v-if="editorType === 'popup'" />
  <SidebarEmailRail v-else />
</template>
